import React, {useMemo} from 'react';
import type {NewsItem} from '../../News';
import {ViewWrapper} from "../../../../components/ViewWrapper/ViewWrapper";
import './NewsCard.css';

export type NewsCardProps = {
  item: NewsItem;
  index: number;
  onExpand: (index: number) => void;
  onCollapse?: (index: number) => void;
  onLinkClicked: (index: number) => void;
};

const NewsCard: React.FC<NewsCardProps> = ({item, index, onExpand, onCollapse, onLinkClicked}) => {

  const filteredDescription = useMemo(() => item.description?.replace(/\r?\n/g, '<br/>'), [item.description]);

  return (
    <div className={`news-card ${item.expanded ? 'expanded-card' : ''}`} onClick={(e) => {
      e.stopPropagation();
      if (item.expanded) {
        onCollapse?.(index);
      } else {
        onExpand(index);
      }
    }}>
      <div className="news-card-main">
        <ViewWrapper disable={item.expanded}>
          <div className="news-text">
            <div className="news-card-title main-title">{item.title}</div>
            {!item.expanded && (
              <button className="news-learn-more" type="button">Learn more</button>
            )}
          </div>
        </ViewWrapper>
        <div className="news-image">
          <img src={item.img} alt={item.title}/>
        </div>
      </div>
      {item.expanded && (
        <div className="news-expanded">
          <div className="news-card-title inner-title">{item.title}</div>
          <div className="news-description" dangerouslySetInnerHTML={{ __html: filteredDescription }} />
          <button className="news-learn-more news-learn-open" type="button" onClick={(e) => {
            e.stopPropagation();
            onLinkClicked(index);
          }}>Read full article
          </button>
        </div>
      )}
    </div>
  );
};

export default NewsCard;
